import Banners from "./banners";
function SiteSettings() {
  return (
    <div className="p-4">
      <div className="text-xl font-semibold">Site Settings</div>
      <Banners />
    </div>
  );
}

export default SiteSettings;
